import Tooltip from "../../common/StyledToolTip";
import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  iconStyle: { cursor: "pointer" },
  commandContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 16px 0 0",
  },
});

const CommandCellRenderer = ({ commandConfig, params, classes }) => {
  return (
    <div
      className={classes.commandContainer}
      onClick={(event) =>
        params.api.runCommand &&
        params.api.runCommand(event.target.getAttribute("data-command"), params)
      }
    >
      {commandConfig.editCommand && (
        <Tooltip title={commandConfig.editTitle}>
          <i
            className={`${classes.iconStyle} icon-icon_edit`}
            data-command={commandConfig.editCommand}
          />
        </Tooltip>
      )}

      {commandConfig.deleteCommand && (
        <Tooltip title={commandConfig.deleteTitle}>
          <i
            className={`${classes.iconStyle} icon-icon_delete`}
            data-command={commandConfig.deleteCommand}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default withStyles(styles)(CommandCellRenderer);
